// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__OQKGl","select":"style_select__SolL5","label":"style_label__D5vbL","wrong":"style_wrong__4jm6o"};